<template>
  <v-card flat outlined color="transparent">
    <v-card-title>
      <v-row>
        <v-col cols="10">
          <h4>{{ item.name || `Расписание ${itemIndex + 1}` }}</h4>
        </v-col>
        <template v-if="!isOnlyEdit">
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :loading="isFormLoading"
                  :disabled="isMutationLoading"
                  v-bind="attrs"
                  v-on="on"
                  @click="$emit('edit', item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </template>
              <span>Редактировать расписание</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="d-d-inline-block">
                  <v-btn
                    icon
                    :loading="isFormLoading"
                    :disabled="isMutationLoading"
                    @click="deleteScheduleHandler(item)"
                  >
                    <v-icon color="red">mdi-trash-can-outline</v-icon></v-btn
                  >
                </div>
              </template>
              <span>Удалить расписание</span>
            </v-tooltip>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :loading="isFormLoading"
                  :disabled="isMutationLoading"
                  v-bind="attrs"
                  v-on="on"
                  @click="$emit('edit', item)"
                ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
              <span>Посмотреть расписание</span>
            </v-tooltip>
          </v-col>
        </template>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-icon v-if="item.startDate" icon="mi-calendar_today" />
            <v-icon v-if="item.repeatType !== 'NO_REPEAT'" icon="mi-repeat" />
            <p v-if="item.startDate">
              <span>
                {{ formatDate(item.startDate, 'DD.MM.YYYY', 'Europe/Moscow') }}
              </span>
              <span v-if="item.endDate && item.repeatType !== 'NO_REPEAT'">
                - {{ formatDate(item.endDate, 'DD.MM.YYYY') }}
              </span>
            </p>
          </v-col>
        </v-row>
        <v-row v-if="chosenWeekDays.length" class="short-event-details__item">
          <v-col cols="12">
            <p class="is-border-box">
              {{ chosenWeekDays }}
            </p>
          </v-col>
        </v-row>
        <v-row v-if="scheduleTimesRanger" class="short-event-details__item">
          <v-col cols="12">
            {{ scheduleTimesRanger }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { getUserTimeFromTime, formatDate } from '@/utils'

export default {
  name: 'CardEventSchedules',
  props: {
    item: {
      type: Object,
      default: () => null
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    chosenWeekDays: {
      type: String,
      default: ''
    },
    isFormLoading: {
      type: Boolean,
      default: false
    },
    isMutationLoading: {
      type: Boolean,
      default: false
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    scheduleTimesRanger () {
      if (this.item?.scheduleTimes) {
        return this.item.scheduleTimes
          .map(scheduleTime => {
            let str = ''
            if (scheduleTime.startTime) {
              str += `с ${getUserTimeFromTime(scheduleTime.startTime)}`
            }
            if (scheduleTime.endTime) {
              str += ` до ${getUserTimeFromTime(scheduleTime.endTime)}`
            }
            return str
          })
          .join(', ')
      }
      return null
    }
  },
  methods: {
    formatDate,
    deleteScheduleHandler (item) {
      this.$emit('delete-event-shedule', item)
    }
  }
}
</script>
